import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'reporting-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit {

  @Input() data: any;

  constructor() { }

  ngOnInit() {
  }

  getTooltip = (status: string, isPart: boolean): string => isPart ? PART_STATUS_TOOLTIP[status] : REQUEST_STATUS_TOOLTIP[status];

}

const REQUEST_STATUS_TOOLTIP = {
  AwaitingReview: "PTE to Accept",
  AwaitingApproval: "TM to Approve",
  ApprovedDesignerRejected: "Designer Reworking WR",
  Approved: "Designer to be Assigned",
  ApprovedWIP: "Designer Assigned/PTE to Review Design",
  Complete: "WR 100% done",
  ReworkRequested: "Requester Reworking WR (Rejected from TM)",
  ReworkInProgress: "Requester Reworking WR (Rejected from PTE)",
  Cancelled: "WR no longer valid",
  OnHold: "WR to be done later",
  TotalCount: "Total of above requests"
}

const PART_STATUS_TOOLTIP = {
  Accepted: "TM to Approve",
  Waived: "Part not required",
  Rejected: "Requester Reworking WR (Rejected from PTE/TM)",
  Complete: "Part 100% done",
  Cancelled: "WR no longer valid",
  Pending: "PTE to Accept",
  Approved: "Designer to be Assigned",
  ApprovedWIP: "Designer Assigned",
  AwaitingDesignerReview: "PTE to Review Design",
  ApprovedDesignerRejected: "Designer Reworking WR",
  TotalCount: "Total of above parts"
}
